/**
 * @fileoverview Active Clients KPI query hook.
 * @description Wraps GET /sales/clients/summary in a TanStack query. The tiles are global: the same
 * for every role, and they ignore the grid's search and filters, so the query takes no input.
 * @copyright Copyright (c) 2026 Brownbox Consulting. All rights reserved.
 * @author Anshul Rokde
 */

import { useQuery } from '@tanstack/react-query'

import { SALES_CRM_QUERY_KEYS } from '@/features/sales/constants/prospects-query-keys.constants'
import { getClientSummary } from '@/features/sales/services/sales-clients.service'

/**
 * @description Fetches the four KPI tiles.
 * @returns {ReturnType<typeof useQuery>} The query (data is the summary).
 */
export function useClientSummary() {
  return useQuery({
    queryKey: SALES_CRM_QUERY_KEYS.clientSummary,
    queryFn: getClientSummary,
  })
}
